module.exports = __webpack_public_path__ + "static/flags/MN-5c633c14349c6874a234397649e370d2.gif";